import Notification from "./base/index";

let messageInstance;
let name = 1;
const prefixKey = "k-message_key_";

function getMessageInstance() {
  messageInstance =
    messageInstance ||
    Notification.newInstance({
      styles: { top: "20px" }
    });

  return messageInstance;
}

function notice(type, content, duration, closable, onClose) {
  let instance = getMessageInstance();

  instance.notice({
    name: `${prefixKey}${name}`,
    type: type,
    duration: duration,
    content: content,
    closable: closable,
    onClose: onClose
  });

  return (function() {
    let target = name++;
    return function() {
      instance.remove(`${prefixKey}${target}`);
    };
  })();
}

const Message = function(options) {
  if (typeof options === "string") {
    options = { content: options };
  }

  return notice(
    options.type,
    options.content,
    options.duration, // 延迟
    options.closable,
    options.onClose
  );
};

// Message.test = function() {
//   console.log("message test");
// };

export default Message;
